export default "__VITE_ASSET__BJW1uuSt__"